import React, { useState, useEffect, useRef } from "react";
import { View, StyleSheet } from "react-native";
import { Label, TextField, PushButton } from "../components/FormComponents";
import {
  Progress,
  ProgressDialog,
  ErrorDialog,
  SuccessDialog,
} from "../components/DialogComponents";
import { executeGet, executePost, api, resCode } from "../utilities/Network";
import { createHeaders, saveHeaders } from "../utilities/System";
import { useSelector, useDispatch } from "react-redux";
import {
  setClientConfiguration,
  setHeaderConfiguration,
  parameters,
  setUserParams,
} from "../reducers/parameterSlice";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { ForgotPasswordDialog } from "../components/DialogComponents";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import { Button } from "@mui/material";
import {
  requestSosmedLogin,
  getGoogleAuthUrl,
  verifySosmedLogin,
  exchangeGoogleCode,
} from "../utilities/GoogleSignIn";

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 48 48">
    <path
      fill="#FFC107"
      d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"
    />
    <path
      fill="#FF3D00"
      d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"
    />
    <path
      fill="#4CAF50"
      d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"
    />
    <path
      fill="#1976D2"
      d="M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.087 5.571l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"
    />
  </svg>
);

//== LOGIN DESKTOP ==//
const Login = (props) => {
  const clientParams = useSelector(parameters);
  const dispatch = useDispatch();

  const emailRef = useRef();
  const passwordRef = useRef();

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [errorEmail, setErrorEmail] = useState(false);
  const [password, setPassword] = useState("");
  const [errorPassword, setErrorPassword] = useState(false);
  const [showForgotPasswordDialog, setShowForgotPasswordDialog] =
    useState(false);
  const initProgress = {
    showProgress: false,
    message: "Harap Tunggu",
    showError: false,
    showSuccess: false,
  };
  const [progressParams, setProgressParams] = useState(initProgress);
  const googleSignInFlag = Object.prototype.hasOwnProperty.call(
    clientParams,
    "google_signin",
  )
    ? clientParams.google_signin
    : localStorage.getItem("google_signin");
  const showGoogleSignIn = String(googleSignInFlag) === "1";

  useEffect(() => {
    if (!window.electron?.receiveMessage) return;

    const unsubscribers = [
      window.electron.receiveMessage("RECEIVE_READ_TOKEN", (params) => {
        let token = params.token;
        let _progress = { ...progressParams };
        _progress.showProgress = true;
        setProgressParams(_progress);
        autoLogin(token);
      }),
      window.electron.receiveMessage("SSO_CALLBACK", (params) => {
        const code = params.code;

        if (code) {
          executeSSOLogin(code);
        }
      }),
      window.electron.receiveMessage("GOOGLE_SIGNIN_CALLBACK", (params) => {
        handleGoogleSignInCallback(params);
      }),
    ];

    return () => {
      unsubscribers.forEach((unsubscribe) => {
        if (typeof unsubscribe === "function") {
          unsubscribe();
        }
      });
    };
  }, []);

  //NOTE - Verify App Token
  const autoLogin = async (token) => {
    const url = api.autoLogin + token;
    const response = await executeGet(url);
    let _initProgress = { ...progressParams };
    _initProgress.showProgress = false;
    setProgressParams(_initProgress);

    if (response.code == 200) {
      let data = response.data;
      global.headers.UUID = data.uuid;
      global.headers.KEY = data.token;
      global.headers.USERNAME = data.username;
      global.headers.USERLEVEL = data.level;
      global.headers.USERID = data.id_user;
      await saveHeaders(global.headers);

      if (data.hasOwnProperty("id_konten")) {
        //alert("SENDING ID KONTEN: " + data.id_konten);
        window.electron.sendMessage("SEND_ID_KONTEN", {
          id_konten: data.id_konten,
        });
      }
      _initProgress.showProgress = true;
      setProgressParams(_initProgress);
      relogin();
    }
  };

  const relogin = async () => {
    let formData = new FormData();
    formData.append("id_user", global.headers.USERID);
    const response = await executePost(api.credentials, formData);
    let _initProgress = { ...progressParams };
    _initProgress.showProgress = false;
    setProgressParams(_initProgress);

    if (response.code == resCode.ok) {
      let newHeaders = {
        CLIENTID: global.headers.CLIENTID,
        UUID: global.headers.UUID,
        OS: global.headers.OS,
        VERSIONCODE: global.headers.VERSIONCODE,
        KEY: response.token,
        USERNAME: response.data.username,
        USERID: response.data.id_user,
        USERLEVEL: response.data.level,
        MAXDAY: clientParams.max_hari,
        MAXCONTENT: clientParams.max_konten,
      };
      let userParams = {
        nama: response.data.nama,
        url_foto: response.data.url_foto,
        troli_donasi: response.data.hasOwnProperty("troli_donasi")
          ? response.data.troli_donasi
          : "0",
        troli_toko: response.data.hasOwnProperty("troli_toko")
          ? response.data.troli_toko
          : "0",
        profile_complete: response.data.profile_complete,
      };

      //setHeaderConfiguration(newHeaders);
      saveHeaders(newHeaders);
      setTimeout(() => {
        props.navigation.reset({
          index: 0,
          routes: [{ name: "Main" }],
        });
      }, 1000);
    }
  };

  //ANCHOR - Login Click
  const onLoginClick = () => {
    if (email.length < 5) {
      setErrorEmail(true);
      return;
    }

    if (password.length < 5) {
      setErrorPassword(true);
      return;
    }

    validateInput();
  };

  //ANCHOR - Confirm Click
  const resetPassword = (email) => {
    setShowForgotPasswordDialog(false);
    let formData = new FormData();
    formData.append("username", email);

    //Tampilkan Progress dialog
    let params = { ...progressParams };
    params.showProgress = true;
    params.message = "Harap Tunggu";
    setProgressParams(params);
    //Eksekusi Reset
    executeReset(formData);
  };
  //ANCHOR - Execute reset password
  const executeReset = async (formData) => {
    const response = await executePost(api.forgotPassword, formData);
    let params = { ...progressParams };

    //Sembunyikan progress dialog
    params.showProgress = false;
    if (response.code == resCode.ok) {
      params.showSuccess = true;
      params.message = response.msg;
      setProgressParams(params);
    } else {
      params.showError = true;
      params.message = response.msg;
      setProgressParams(params);
    }
  };

  //ANCHOR - On Email Press
  const onEmailPress = (event) => {
    if (event.key == "Enter") {
      passwordRef.current.focus();
    }
  };
  //ANCHOR - On Password Press
  const onPasswordPress = (event) => {
    if (event.key == "Enter") {
      validateInput();
    }
  };

  //ANCHOR - Validate Input
  const validateInput = () => {
    emailRef.current.focus();
    if (email == "" || email.length < 5) {
      setErrorEmail(true);
      emailRef.current.focus();
      return;
    }

    if (password == "" || password.length < 5) {
      setErrorPassword(true);
      passwordRef.current.focus();
      return;
    }

    //Tampilkan Progress Dialog
    let params = { ...progressParams };
    params.showProgress = true;

    params.message = "Autentikasi";
    setProgressParams(params);

    let formData = new FormData();
    formData.append("user", email);
    formData.append("pass", password);
    executeLogin(formData);
  };

  //ANCHOR - Execute Login
  const executeLogin = async (formData) => {
    const response = await executePost(api.login, formData);
    let params = { ...progressParams };
    params.showProgress = false;
    if (response.code == resCode.ok) {
      setProgressParams(params);

      let newHeaders = {
        CLIENTID: global.headers.CLIENTID,
        UUID: global.headers.UUID,
        OS: global.headers.OS,
        VERSIONCODE: global.headers.VERSIONCODE,
        KEY: response.token,
        USERNAME: response.data.username,
        USERID: response.data.id_user,
        USERLEVEL: response.data.level,
        MAXDAY: clientParams.max_hari,
        MAXCONTENT: clientParams.max_konten,
      };

      window.electron.sendMessage("SET-USERNAME", {
        username: response.data.username,
      });
      dispatch(setHeaderConfiguration(newHeaders));
      saveHeaders(newHeaders);
      let userParams = {
        nama: response.data.nama,
        foto: response.data.url_foto,
        troli_donasi: response.data.hasOwnProperty("troli_donasi")
          ? response.data.troli_donasi
          : "0",
        troli_toko: response.data.hasOwnProperty("troli_toko")
          ? response.data.troli_toko
          : "0",
        profile_complete: response.data.profile_complete,
      };
      dispatch(setUserParams(userParams));
      props.navigation.reset({
        index: 0,
        routes: [{ name: "Main" }],
      });
    } else {
      params.showError = true;
      params.message = response.msg;
      setProgressParams(params);
    }
  };

  //ANCHOR - Login with SSO
  const loginWithSSO = async () => {
    const storageRaw = localStorage.getItem(`${clientParams.kode}`);
    if (!storageRaw) {
      alert("Data perangkat belum tersedia. Muat ulang aplikasi.");
      return;
    }

    const storage = JSON.parse(storageRaw);
    const os = storage.OS;
    const uuid = storage.UUID;
    const clientId = storage.CLIENTID;

    setProgressParams({
      ...progressParams,
      showProgress: true,
      showError: false,
      message: "Menyiapkan login institusi...",
    });

    try {
      const formData = new FormData();
      formData.append("kode", clientParams.kode);
      formData.append("os", os);

      const response = await fetch(api.loginWithSSO, {
        method: "post",
        headers: {
          OS: os,
          UUID: uuid,
          CLIENTID: clientId,
        },
        body: formData,
      });
      const data = JSON.parse(await response.text());

      // Tutup loading dulu, baru buka window SSO
      setProgressParams({
        ...progressParams,
        showProgress: false,
        showError: false,
      });

      if (data.code !== resCode.ok) {
        setProgressParams({
          ...progressParams,
          showProgress: false,
          showError: true,
          message: data.msg || "Gagal memulai login institusi",
        });
        return;
      }

      const url = data?.data?.auth_url;
      if (!url) {
        setProgressParams({
          ...progressParams,
          showProgress: false,
          showError: true,
          message: "URL login institusi tidak ditemukan",
        });
        return;
      }

      // SSO LKPP memblokir iframe (X-Frame-Options: deny),
      // jadi buka di window Electron / tab browser.
      if (window.electron?.sendMessage) {
        window.electron.sendMessage("OPEN_URL", url);
      } else {
        window.open(url, "_blank", "noopener,noreferrer");
      }
    } catch (error) {
      setProgressParams({
        ...progressParams,
        showProgress: false,
        showError: true,
        message: "Gagal memulai login institusi",
      });
    }
  };

  const executeSSOLogin = async (code) => {
    const storageRaw = localStorage.getItem(`${clientParams.kode}`);
    if (!storageRaw) {
      alert("Data perangkat belum tersedia. Muat ulang aplikasi.");
      return;
    }

    const storage = JSON.parse(storageRaw);
    const os = storage.OS;
    const uuid = storage.UUID;
    const clientId = storage.CLIENTID;

    setProgressParams({
      showProgress: true,
      showError: false,
      showSuccess: false,
      message: "Menyelesaikan login institusi...",
    });

    try {
      const formData = new FormData();
      formData.append("code", code);

      const response = await fetch(api.signInSSO, {
        method: "post",
        headers: {
          OS: os,
          UUID: uuid,
          CLIENTID: clientId,
        },
        body: formData,
      });

      const data = JSON.parse(await response.text());

      if (data.code == resCode.ok) {
        const userData = data.data || {};

        const newHeaders = {
          CLIENTID: global.headers.CLIENTID || clientId,
          UUID: global.headers.UUID || uuid,
          OS: global.headers.OS || os,
          VERSIONCODE: global.headers.VERSIONCODE,
          KEY: data.token || userData.token,
          USERNAME: userData.username,
          USERID: userData.id_user,
          USERLEVEL: userData.level,
          MAXDAY: clientParams.max_hari,
          MAXCONTENT: clientParams.max_konten,
        };

        if (window.electron?.sendMessage) {
          window.electron.sendMessage("SET-USERNAME", {
            username: userData.username,
          });
        }

        dispatch(setHeaderConfiguration(newHeaders));
        saveHeaders(newHeaders);

        const userParams = {
          nama: userData.nama,
          foto: userData.url_foto,
          troli_donasi: userData.hasOwnProperty("troli_donasi")
            ? userData.troli_donasi
            : "0",
          troli_toko: userData.hasOwnProperty("troli_toko")
            ? userData.troli_toko
            : "0",
          profile_complete: userData.profile_complete,
        };
        dispatch(setUserParams(userParams));

        setProgressParams({
          showProgress: false,
          showError: false,
          showSuccess: false,
          message: "",
        });

        props.navigation.reset({
          index: 0,
          routes: [{ name: "Main" }],
        });
      } else {
        setProgressParams({
          showProgress: false,
          showError: true,
          showSuccess: false,
          message: data.msg || "Gagal melakukan login institusi",
        });
      }
    } catch (error) {
      setProgressParams({
        showProgress: false,
        showError: true,
        showSuccess: false,
        message: "Gagal melakukan login institusi",
      });
    }
  };

  const handleGoogleSignInCallback = async (params) => {
    if (params?.cancelled) {
      setProgressParams({
        showProgress: false,
        showError: false,
        showSuccess: false,
        message: "",
      });
      return;
    }

    if (params?.error) {
      setProgressParams({
        showProgress: false,
        showError: true,
        showSuccess: false,
        message: params.error,
      });
      return;
    }

    // Deep link / Electron .env: email + token Kubuku
    if (params?.email && params?.token) {
      await completeGoogleSignIn(
        params.email,
        params.fullname || params.email,
        params.token,
      );
      return;
    }

    // Deep link API: code → tukar ke BE
    if (params?.code) {
      setProgressParams({
        showProgress: true,
        showError: false,
        showSuccess: false,
        message: "Menyelesaikan login Google...",
      });
      try {
        const response = await exchangeGoogleCode(params.code);
        const userData = response.data || {};
        await applyGoogleSession(response, userData);
      } catch (error) {
        setProgressParams({
          showProgress: false,
          showError: true,
          showSuccess: false,
          message: error.message || "Gagal login dengan Google",
        });
      }
    }
  };

  const loginWithGoogle = async () => {
    if (!window.electron?.sendMessage) {
      setProgressParams({
        ...progressParams,
        showProgress: false,
        showError: true,
        showSuccess: false,
        message: "Login Google hanya tersedia di aplikasi desktop",
      });
      return;
    }

    setProgressParams({
      ...progressParams,
      showProgress: true,
      showError: false,
      showSuccess: false,
      message: "Menyiapkan login Google...",
    });
    try {
      const response = await requestSosmedLogin();
      const authUrl = getGoogleAuthUrl(response);

      setProgressParams({
        ...progressParams,
        showProgress: true,
        showError: false,
        showSuccess: false,
        message: "Menunggu akun Google...",
      });

      // API ready → Electron hanya buka tab.
      // Belum ada authUrl → fallback .env di Electron (uuid/clientId).
      if (authUrl) {
        window.electron.sendMessage("GOOGLE_SIGNIN_START", { authUrl });
      } else {
        window.electron.sendMessage("GOOGLE_SIGNIN_START", {
          uuid: global.headers.UUID,
          clientId: global.headers.CLIENTID,
        });
      }
    } catch (error) {
      setProgressParams({
        ...progressParams,
        showProgress: false,
        showError: true,
        showSuccess: false,
        message: error.message || "Gagal memulai login Google",
      });
    }
  };

  const applyGoogleSession = async (response, userData) => {
    const newHeaders = {
      CLIENTID: global.headers.CLIENTID,
      UUID: global.headers.UUID,
      OS: global.headers.OS,
      VERSIONCODE: global.headers.VERSIONCODE,
      KEY: response.token || userData.token,
      USERNAME: userData.username,
      USERID: userData.id_user,
      USERLEVEL: userData.level,
      MAXDAY: clientParams.max_hari,
      MAXCONTENT: clientParams.max_konten,
    };
    if (window.electron?.sendMessage) {
      window.electron.sendMessage("SET-USERNAME", {
        username: userData.username,
      });
    }
    dispatch(setHeaderConfiguration(newHeaders));
    saveHeaders(newHeaders);
    dispatch(
      setUserParams({
        nama: userData.nama,
        foto: userData.url_foto,
        troli_donasi: userData.hasOwnProperty("troli_donasi")
          ? userData.troli_donasi
          : "0",
        troli_toko: userData.hasOwnProperty("troli_toko")
          ? userData.troli_toko
          : "0",
        profile_complete: userData.profile_complete,
      }),
    );
    setProgressParams({
      showProgress: false,
      showError: false,
      showSuccess: false,
      message: "",
    });
    props.navigation.reset({
      index: 0,
      routes: [{ name: "Main" }],
    });
  };

  const completeGoogleSignIn = async (email, fullname, jwtToken) => {
    setProgressParams({
      showProgress: true,
      showError: false,
      showSuccess: false,
      message: "Menyelesaikan login Google...",
    });

    try {
      const response = await verifySosmedLogin(email, fullname, jwtToken);
      await applyGoogleSession(response, response.data || {});
    } catch (error) {
      setProgressParams({
        showProgress: false,
        showError: true,
        showSuccess: false,
        message: error.message || "Gagal login dengan Google",
      });
    }
  };

  return (
    <View style={styles.container} tabIndex={0}>
      {
        //LEFT SIDE
      }
      <View style={styles.leftSide}>
        <img
          src={clientParams.url_logo_login}
          style={{
            width: 450,
            height: "auto",
          }}
        />
      </View>
      <View style={styles.rightSide}>
        <Label
          weight={"600"}
          size={16}
          text={"Masuk ke akun anda"}
          style={{
            marginTop: 16,
            marginLeft: 16,
            marginBottom: 16,
          }}
        />
        <View
          style={{
            height: 0.5,
            backgroundColor: "silver",
            width: "100%",
            marginBottom: 16,
          }}
        />
        <TextField
          ref={emailRef}
          labelText="ID"
          marginLeft={16}
          marginRight={16}
          onChange={(text) => {
            setEmail(text);
            setErrorEmail(false);
          }}
          placeholder={"Masukkan ID pengguna"}
          error={errorEmail}
          errorText={"Harap masukkan ID anda"}
          onKeyPress={onEmailPress}
        />
        <TextField
          ref={passwordRef}
          labelText="Password"
          marginTop={16}
          marginLeft={16}
          marginRight={16}
          onChange={(text) => {
            setPassword(text);
            setErrorPassword(false);
          }}
          placeholder={"Masukkan password"}
          type={passwordVisible ? "text" : "password"}
          withIcon={true}
          icon={
            passwordVisible ? (
              <VisibilityOffOutlinedIcon />
            ) : (
              <VisibilityOutlinedIcon />
            )
          }
          onIconClick={() => {
            passwordVisible
              ? setPasswordVisible(false)
              : setPasswordVisible(true);
          }}
          error={errorPassword}
          errorText={"Harap masukkan password anda"}
          onKeyPress={onPasswordPress}
        />
        <View
          style={{
            flexDirection: "row-reverse",
            marginTop: 12,
            marginRight: 16,
            marginBottom: 16,
          }}
        >
          {clientParams.url_sso == "0" && (
            <Label
              weight={"600"}
              size={12}
              color={"#2980b9"}
              text={"Lupa Password?"}
              style={{
                cursor: "pointer",
              }}
              onClick={() => {
                setShowForgotPasswordDialog(true);
              }}
            />
          )}
        </View>
        <PushButton
          text={"Login"}
          textWeight={"400"}
          variant="contained"
          style={{
            marginLeft: 16,
            marginRight: 16,
            borderRadius: 8,
          }}
          onClick={onLoginClick}
        />
        {clientParams.url_sso == "0" && (
          <View
            style={{
              marginTop: 16,
              marginLeft: 16,
              marginRight: 16,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Label
              size={12}
              style={{ marginRight: 4 }}
              weight={"600"}
              text={"Belum punya akun?"}
            />
            <Label
              size={12}
              style={{ marginRight: 4, cursor: "pointer" }}
              weight={"600"}
              color={clientParams.warna_header}
              text={"daftar disini"}
              onClick={() => {
                props.navigation.navigate("SignUp");
              }}
            />
          </View>
        )}

        {clientParams.url_sso == "1" && (
          <View
            style={{
              marginTop: 20,
              marginLeft: 16,
              marginRight: 16,
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <View
              style={{
                width: "100%",
                flexDirection: "row",
                alignItems: "center",
                marginBottom: 16,
              }}
            >
              <View
                style={{ flex: 1, height: 1, backgroundColor: "#eceff1" }}
              />
              <Label
                size={11}
                weight={"600"}
                color={"#90a4ae"}
                text={"atau"}
                style={{ marginLeft: 10, marginRight: 10 }}
              />
              <View
                style={{ flex: 1, height: 1, backgroundColor: "#eceff1" }}
              />
            </View>

            <View
              style={{
                width: 44,
                height: 44,
                borderRadius: 22,
                backgroundColor:
                  (clientParams.warna_header || "#2980b9") + "14",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 10,
              }}
            >
              <ApartmentOutlinedIcon
                style={{
                  fontSize: 24,
                  color: clientParams.warna_header || "#2980b9",
                }}
              />
            </View>

            <Label
              size={13}
              weight={"600"}
              text={"Login dengan Institusi"}
              textAlign={"center"}
            />
            <Label
              size={11}
              weight={"400"}
              color={"#7f8c8d"}
              text={"Gunakan akun institusi atau organisasi Anda"}
              textAlign={"center"}
              style={{ marginTop: 4, marginBottom: 12 }}
            />

            <Button
              variant="outlined"
              startIcon={<ApartmentOutlinedIcon />}
              onClick={loginWithSSO}
              style={{
                width: "100%",
                borderRadius: 8,
                textTransform: "none",
                paddingTop: 8,
                paddingBottom: 8,
                borderColor: clientParams.warna_header,
                color: clientParams.warna_header,
                fontFamily: "Poppins",
                fontWeight: "600",
                fontSize: 13,
              }}
            >
              Lanjutkan ke Institusi
            </Button>
          </View>
        )}

        {showGoogleSignIn && (
          <View
            style={{
              marginTop: clientParams.url_sso == "1" ? 12 : 20,
              marginLeft: 16,
              marginRight: 16,
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {clientParams.url_sso != "1" && (
              <View
                style={{
                  width: "100%",
                  flexDirection: "row",
                  alignItems: "center",
                  marginBottom: 16,
                }}
              >
                <View
                  style={{ flex: 1, height: 1, backgroundColor: "#eceff1" }}
                />
                <Label
                  size={11}
                  weight={"600"}
                  color={"#90a4ae"}
                  text={"atau"}
                  style={{ marginLeft: 10, marginRight: 10 }}
                />
                <View
                  style={{ flex: 1, height: 1, backgroundColor: "#eceff1" }}
                />
              </View>
            )}

            <Button
              variant="outlined"
              startIcon={<GoogleIcon />}
              onClick={loginWithGoogle}
              style={{
                width: "100%",
                borderRadius: 8,
                textTransform: "none",
                paddingTop: 8,
                paddingBottom: 8,
                borderColor: "#dadce0",
                color: "#3c4043",
                backgroundColor: "#fff",
                fontFamily: "Poppins",
                fontWeight: "600",
                fontSize: 13,
              }}
            >
              Lanjutkan dengan Google
            </Button>
          </View>
        )}
      </View>

      <ForgotPasswordDialog
        open={showForgotPasswordDialog}
        onCancelClick={() => {
          setShowForgotPasswordDialog(false);
        }}
        onConfirmClick={resetPassword}
      />
      <ProgressDialog
        open={progressParams.showProgress}
        message={progressParams.message}
      />
      <ErrorDialog
        open={progressParams.showError}
        message={progressParams.message}
        label={"OK"}
        onClick={() => {
          let params = { ...progressParams };
          params.showError = false;
          setProgressParams(params);
        }}
      />
      <SuccessDialog
        open={progressParams.showSuccess}
        message={progressParams.message}
        label={"OK"}
        onClick={() => {
          let params = { ...progressParams };
          params.showSuccess = false;
          setProgressParams(params);
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "white",
    flexDirection: "row",
  },
  leftSide: {
    flex: 0.7,
    borderRightWidth: 0.3,
    borderColor: "silver",
    alignItems: "center",
    justifyContent: "center",
  },
  rightSide: {
    flex: 0.3,
    backgroundColor: "white",
  },
});

export { Login };
